export default [
    {
        "error_id": "BCF-01",
        "data": [
            {
                "cross_section": "42127",
                "type": "Culvert"
            }
        ]
    }
]